<div class="form-holder" *ngIf="emailConfig$ | async as emailConfig">
    <div class="form-header">
        <span class="form-title">{{ emailConfig?.title }}</span>
    </div>
    <div class="form-content form-visible">
        <form id="user-email-form">
            <div class="row">
                <div class="col-12">
                    <input
                        #emailField
                        [value]="userEmail | async"
                        disabled
                        class="disabled"
                        type="text"
                        id="email"
                        placeholder=""
                        name="email"
                    />
                </div>
            </div>
        </form>
    </div>
</div>
